import { create } from 'zustand';
import { NavigationState, AppScreen, NavigationCategory } from '../types';

const initialCategories: NavigationCategory[] = [
  {
    id: 'front-office',
    title: 'Front Office',
    icon: 'Building2',
    isCollapsed: false,
    screens: ['reservation-calendar', 'banquet-management', 'corporate-outings']
  },
  {
    id: 'point-of-sale',
    title: 'Point of Sale',
    icon: 'CreditCard',
    isCollapsed: true,
    screens: ['restaurant-management', 'bar-management']
  },
  {
    id: 'back-office',
    title: 'Back Office',
    icon: 'Settings',
    isCollapsed: true,
    screens: ['room-management', 'inventory']
  },
  {
    id: 'guests-crm',
    title: 'Guests & CRM',
    icon: 'Users',
    isCollapsed: true,
    screens: ['crm', 'loyalty']
  },
  {
    id: 'admin',
    title: 'Human Resource',
    icon: 'Users',
    isCollapsed: true,
    screens: ['user-management']
  },
  {
    id: 'accounts',
    title: 'Accounts',
    icon: 'DollarSign',
    isCollapsed: true,
    screens: ['finance-accounting']
  },
  {
    id: 'insights',
    title: 'AI Insights',
    icon: 'BarChart3',
    isCollapsed: true,
    screens: ['insights', 'reporting-center']
  },
];

export const useNavigationStore = create<NavigationState>((set) => ({
  currentScreen: 'reservation-calendar',
  isSidebarCollapsed: false,
  categories: initialCategories,

  navigateTo: (screen: AppScreen) => {
    set({ currentScreen: screen });
  },

  toggleSidebar: () => {
    set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed }));
  },

  toggleCategory: (categoryId: string) => {
    set((state) => ({
      categories: state.categories.map(category =>
        category.id === categoryId
          ? { ...category, isCollapsed: !category.isCollapsed }
          : category
      )
    }));
  },
}));

